module.exports = __webpack_public_path__ + "static/media/ico-campaign.737c9eca.svg";